// GETTERS
export const CERTIFICATE_TYPES = "certificate/CERTIFICATE_TYPES";
export const CERTIFICATES_SEARCH_RESULT = "certificate/CERTIFICATES_SEARCH_RESULT";
export const NEW_CERTIFICATE_TYPE_SIDEBAR = "certificate/NEW_CERTIFICATE_TYPE_SIDEBAR";
export const MANAGE_CERTIFICATE_TYPES_SIDEBAR = "certificate/MANAGE_CERTIFICATE_TYPES_SIDEBAR";

// ACTIONS
export const SEARCH_CERTIFICATES = "certificate/SEARCH_CERTIFICATES";
export const GET_CERTIFICATE_TYPES = "certificate/GET_CERTIFICATE_TYPES";
export const OPEN_NEW_CERTIFICATE_TYPE_SIDEBAR = "certificate/OPEN_NEW_CERTIFICATE_TYPE_SIDEBAR";
export const SAVE_CERTIFICATE_TYPE = "certificate/SAVE_CERTIFICATE_TYPE";
export const OPEN_MANAGE_CERTIFICATE_TYPES_SIDEBAR = "certificate/OPEN_MANAGE_CERTIFICATE_TYPES_SIDEBAR";
export const UPDATE_CERTIFICATE_TYPE = "certificate/UPDATE_CERTIFICATE_TYPE";

// MUTATIONS
export const MUTATE_CERTIFICATE_TYPES = "certificate/MUTATE_CERTIFICATE_TYPES";
export const MUTATE_CERTIFICATES_SEARCH_RESULT = "certificate/MUTATE_CERTIFICATES_SEARCH_RESULT";
export const MUTATE_NEW_CERTIFICATE_TYPE_SIDEBAR = "certificate/MUTATE_NEW_CERTIFICATE_TYPE_SIDEBAR";
export const MUTATE_MANAGE_CERTIFICATE_TYPES_SIDEBAR = "certificate/MUTATE_MANAGE_CERTIFICATE_TYPES_SIDEBAR";
